import type {VehicleFuelLevel} from "../types";

/** Display labels for fuel level; API values stay snake_case. */
export const VEHICLE_FUEL_LEVEL_LABELS: Record<VehicleFuelLevel, string> = {
  empty: "Empty",
  quarter: "1/4",
  half: "1/2",
  three_quarters: "3/4",
  full: "Full",
};

export function formatVehicleFuelLevelLabel(level: string | null | undefined): string {
  if (level == null || level === "") return "";
  if (level in VEHICLE_FUEL_LEVEL_LABELS) {
    return VEHICLE_FUEL_LEVEL_LABELS[level as VehicleFuelLevel];
  }
  return level;
}
